import Vue from "vue";
import {
	ERequestType,
	fetchGetHelper,
	fetchPostHelper,
	fetchPutHelper,
} from "../../tools/fetch";
import * as mutationTypes from "../types/table-move";

/*************************************
 State
 **/
const state = {
	// store vars
	modAddTable: false,
	modEdition: false,
	modLinkTable: false,
	isLoaded: false,
	unit: 25,
	// rooms datas
	selectedRoom: "",
	roomsDatas: {},
	lockedRooms: [],
	lockedTables: [],
	roomsDatasUnsubscribe: null,
	roomsDatasUnsubscribe2: [],
	widthStage: 100,
	heightStage: 100,
	countRoom: 0,
	allRoomsIsLoaded: false,
	// tables datas
	tableIsLoaded: false,
	displayTablesIds: [],
	selectedTables: [],
	tableIsDraggable: true,
};

/*************************************
 Getters
 **/
const getters = {
	/** store getters **/
	getModEdition: function (state) {
		if (state.tableIsDraggable) return state.modEdition;
		else return false;
	},
	getStyleEdition: function (state) {
		return state.modEdition;
	},
	getModLinkTable: function (state) {
		return state.modLinkTable;
	},
	getModAddTable: function (state) {
		return state.modAddTable;
	},
	getUnitGrid: function (state) {
		return state.unit;
	},
	getUnitTable: function (state) {
		return state.unit * 2;
	},
	getStoreRoomsIsLoaded: function (state) {
		return state.isLoaded;
	},
	getAllRoomsIsLoaded: function (state) {
		return state.allRoomsIsLoaded;
	},

	/**
	 * get all services of current resto
	 * @param {*} state
	 */
	getLockedRooms: function (state) {
		return state.lockedRooms;
	},
	/**
	 * get all services of current resto
	 * @param {*} state
	 */
	getLockedTables: function (state) {
		return state.lockedTables;
	},
	/**
	 * get room locked state
	 * @param {*} state
	 * @returns boolean
	 */
	getRoomIsLocked: (state) => (payload) => {
		let find = state.lockedRooms.find((el) => {
			return (
				el.room === payload.room &&
				el.ts === payload.ts &&
				el.service === payload.service
			);
		});
		if (find !== undefined) return true;
		return false;
	},

	/** rooms getters **/
	getRoomsDatas: function (state) {
		if (Object.keys(state.roomsDatas).length > 0) return state.roomsDatas;
		else return null;
	},
	getSelectedRoom: function (state) {
		return state.selectedRoom;
	},
	getSelectedRoomName: function (state) {
		if (
			state.selectedRoom !== "" &&
			state.roomsDatas[state.selectedRoom] !== undefined
		)
			return state.roomsDatas[state.selectedRoom].name;
		else return "";
	},
	getRoomName: (state) => (room) => {
		return state.roomsDatas[room].name;
	},
	getRoomNbCouvertsBookedById: (state) => (rId) => {
		return state.roomsDatas[rId].nbCouvertsBooked;
	},
	getRoomNbCouvertsLocked:
		(state, getters, rootState, rootGetters) => (payload) => {
			let ts = rootGetters["calendar/getDateToTimestamp"](payload.date);
			let found = state.lockedTables.find((locked) => {
				return (
					locked.ts === ts &&
					locked.service === payload.service &&
					locked.room === payload.room
				);
			});
			let nbCouvLocked = 0;
			if (found) {
				found.tables.forEach((table) => {
					nbCouvLocked += table.nbCouvert;
				});
			}
			return nbCouvLocked;
		},
	getRoomNbCouvertsLockedAllRooms:
		(state, getters, rootState, rootGetters) => (payload) => {
			let ts = rootGetters["calendar/getDateToTimestamp"](payload.date);
			let found = state.lockedTables.filter((locked) => {
				return locked.ts === ts && locked.service === payload.service;
			});
			let nbCouvLocked = 0;
			if (found && found.length > 0) {
				found.forEach((entry) => {
					entry.tables.forEach((table) => {
						nbCouvLocked += table.nbCouvert;
					});
				});
			}
			return nbCouvLocked;
		},
	getAllCouverts:
		(state, getters, rootState, rootGetters) => (date, service) => {
			let nb = 0;
			let ts = rootGetters["calendar/getDateToTimestamp"](date);
			Object.entries(state.roomsDatas).forEach(([rid, rData]) => {
				let locked = getters["getRoomIsLocked"]({
					room: rid,
					ts: ts,
					service: service,
				});
				if (!locked) nb += rData.nbCouverts;
			});
			return nb;
		},

	getThisTableIsLock: (state, getters, rootState, rootGetters) => (payload) => {
		if (
			state.lockedTables.length === 0 &&
			payload.date &&
			payload.service &&
			payload.room &&
			payload.id
		)
			return false;
		else {
			let ts = rootGetters["calendar/getDateToTimestamp"](payload.date);
			let foundMain = state.lockedTables.find((t) => {
				return (
					t.ts === ts &&
					t.service === payload.service &&
					t.room === payload.room
				);
			});
			let found;
			if (foundMain) {
				found = foundMain.tables.find((t) => {
					return t.idT === payload.id;
				});
			}

			if (found === undefined) return false;
			else return true;
		}
	},
	/**
	 * get tables locked for selected service
	 */
	getCurrentLockedTables:
		(state, getters, rootState, rootGetters) => (payload) => {
			if (state.lockedTables.length === 0) return [];
			let ts = rootGetters["calendar/getDateToTimestamp"](payload.date);
			let found = state.lockedTables.find((t) => {
				return (
					t.ts === ts &&
					t.service === payload.service &&
					t.room === payload.room
				);
			});
			if (found === undefined || found.length === 0) return [];
			else {
				let ids = [];
				found.tables.forEach((table) => {
					ids.push(table.id);
				});
				return ids;
			}
		},

	/** tables getters **/
	getTables: function (state, getters) {
		if (
			getters["getRoomsDatas"] != null &&
			state.selectedRoom !== "" &&
			state.roomsDatas[state.selectedRoom] !== undefined
		) {
			if (Object.keys(state.roomsDatas[state.selectedRoom].tables).length > 0)
				return state.roomsDatas[state.selectedRoom].tables;
			else return null;
		} else {
			return null;
		}
	},
	getTablesByRoom: (state, getters) => (r) => {
		if (
			getters["getRoomsDatas"] != null &&
			r !== "" &&
			state.roomsDatas[r] !== undefined
		) {
			if (Object.keys(state.roomsDatas[r].tables).length > 0)
				return state.roomsDatas[r].tables;
		}
		return null;
	},
	getSelectedTables: function (state) {
		return state.selectedTables;
		// return state.roomsDatas[state.selectedRoom].tables
	},
	getDisplayTableIds: function (state) {
		return state.displayTablesIds;
	},
	getDisplayTableById: (state) => (tid) => {
		if (state.roomsDatas[state.selectedRoom] !== undefined)
			return state.roomsDatas[state.selectedRoom].tables[tid];
		else return [];
	},
	getTableIsLoaded: function (state) {
		return state.tableIsLoaded;
	},
	getNewTableData: (state) => (data) => {
		let posX = 25;
		let posY = 25;
		if (
			state.selectedRoom !== undefined &&
			state.roomsDatas[state.selectedRoom] !== undefined &&
			Object.keys(state.roomsDatas[state.selectedRoom].tables).length > 0
		) {
			posX =
				state.roomsDatas[state.selectedRoom].tables[
					state.displayTablesIds[state.displayTablesIds.length - 1]
				].x + state.unit;
			posY =
				state.roomsDatas[state.selectedRoom].tables[
					state.displayTablesIds[state.displayTablesIds.length - 1]
				].y + state.unit;
		}
		return {
			id: data.id,
			roomid: state.selectedRoom,
			idT: data.id,
			width: data.width,
			height: data.height,
			nbCouvert: data.nbCouvert,
			angle: data.angle,
			forme: data.style,
			x: posX,
			y: posY,
			isDragging: false,
			isBooked: false,
			isOccuped: false,
			isInLate: false,
			isLock: false,
			resaId: [],
		};
	},
	getLinkedTables: function (state, getters, rootState, rootGetters) {
		let linked = {};
		if (
			rootGetters["newReservations/getCurrentResas"] !== null &&
			getters["getTables"] !== null &&
			getters["getTables"] !== undefined
		) {
			Object.entries(getters["getTables"]).forEach(([tid, table]) => {
				if (
					table.resaId !== null &&
					table.resaId !== undefined &&
					table.resaId.length > 0
				) {
					table.resaId.forEach((resaId) => {
						// only show linked table if selctedresa is setted
						if (
							rootGetters["newReservations/getSelectedResa"] !== null &&
							rootGetters["newReservations/getSelectedResa"].id === resaId
						) {
							if (linked[resaId] === undefined) linked[resaId] = [];
							linked[resaId].push(table);
						}
					});
				}
			});
		}
		return linked;
	},
	getLinkedResaIdsToTable:
		(state, getters, rootState, rootGetters) =>
		(room, tid, ignoreSelectedResa = false) => {
			if (room !== "") {
				if (ignoreSelectedResa) {
					let rids = state.roomsDatas[room].tables[tid]["resaId"].slice(0);
					let index = rids.findIndex((element) => {
						return (
							element === rootGetters["newReservations/getSelectedResa"].id
						);
					});
					if (index !== -1) rids.splice(index, 1);
					return rids;
				} else {
					return state.roomsDatas[room].tables[tid]["resaId"];
				}
			} else return [];
		},
	getTableDatas: (state) => (room, tid) => {
		return state.roomsDatas[room].tables[tid];
	},
	getHoursDispoForSelectedTable:
		(state, getters, rootState, rootGetters) =>
		(ignoreSelectedResa = false) => {
			let hours = [];
			let countUnAvaible = 0;
			getters["getSelectedTables"].forEach((tid) => {
				let hoursTable = rootGetters["newReservations/getHourAvaibleForResas"](
					getters["getLinkedResaIdsToTable"](
						getters["getSelectedRoom"],
						tid,
						ignoreSelectedResa,
					),
				);
				// check number of table is unvaible
				if (hoursTable.length === 0) countUnAvaible++;
				// init if is first
				if (hours.length === 0) hours = hoursTable.slice(0);
				else if (hoursTable.length > 0) {
					hoursTable.forEach((h) => {
						let index = hours.findIndex((element) => {
							return element === h;
						});
						if (index === -1) hours.splice(index, 1);
					});
				}
			});
			if (countUnAvaible > 0) return [];
			else return hours;
		},
};

/*************************************
 Mutations
 **/
const mutations = {
	/** store mutations **/
	setModAddTable(state, bool) {
		state.modAddTable = bool;
	},
	setModEdition(state, bool) {
		state.modEdition = bool;
	},
	setModLinkTable(state, bool) {
		state.modLinkTable = bool;
	},
	setLoadedState(state, val) {
		state.isLoaded = val;
	},
	setRoomsLoadedState(state, val) {
		state.allRoomsIsLoaded = val;
	},

	/** rooms mutations **/
	setRoomsDatas(state, dbData) {
		Vue.set(state.roomsDatas, dbData.id.toString(), dbData.data);
	},
	setSelectedRoom(state, id) {
		state.selectedRoom = id;
	},
	setRoomNbCouvertsBooked(state, data) {
		state.roomsDatas[data.id].nbCouvertsBooked = data.value;
	},
	setWidthAndHeight(state, data) {
		state.widthStage = data.width;
		state.heightStage = data.height;
	},

	/** tables mutations **/
	[mutationTypes.START_MOVE](state, { tableId }) {
		if (
			state.roomsDatas[state.selectedRoom].tables !== undefined &&
			state.modEdition
		) {
			Object.entries(state.roomsDatas[state.selectedRoom].tables).forEach(
				([tid, table]) => {
					if (table.id === tableId) {
						table.isDragging = true;
					}
				},
			);
		}
	},
	[mutationTypes.STOP_MOVE](state, { tableId }) {
		if (
			state.roomsDatas[state.selectedRoom].tables !== undefined &&
			state.modEdition
		) {
			Object.entries(state.roomsDatas[state.selectedRoom].tables).forEach(
				([tid, table]) => {
					if (table.id === tableId) {
						table.isDragging = false;
					}
				},
			);
		}
	},
	[mutationTypes.MOVE](state, { tableId, position, absoPos }) {
		if (
			state.roomsDatas[state.selectedRoom].tables !== undefined &&
			state.modEdition
		) {
			Object.entries(state.roomsDatas[state.selectedRoom].tables).forEach(
				([tid, table]) => {
					if (table.id === tableId) {
						if (absoPos.x > 25 && absoPos.x < state.widthStage - 25)
							table.x = position.x;
						if (absoPos.y > 25 && absoPos.y < state.heightStage - 25)
							table.y = position.y;
					}
				},
			);
		}
	},
	[mutationTypes.SELECTED](state, { tableId, position }) {},
	setTableIsDraggable(state, bool) {
		state.tableIsDraggable = bool;
	},
	setSelectedTable(state, id) {
		if (state.modEdition) state.selectedTables = [];
		state.selectedTables.push(id);
	},
	setSelectedTables(state, ids) {
		state.selectedTables = ids;
	},
	setUnSelectedTables(state) {
		state.selectedTables = [];
	},
	setDisplayTableIds(state) {
		let tids = [];
		if (state.roomsDatas[state.selectedRoom] !== undefined) {
			Object.entries(state.roomsDatas[state.selectedRoom].tables).forEach(
				([tId, tData]) => {
					tids.push(filterInt(tId.toString()));
				},
			);
			tids.sort(function (a, b) {
				return a - b;
			});
		}
		state.tableIsLoaded = true;
		state.displayTablesIds = tids;
	},
	setTable(state, tData) {
		Vue.set(state.roomsDatas[state.selectedRoom].tables, tData.id, tData);
	},
	setTableDiameter(state, tData) {
		state.roomsDatas[state.selectedRoom].tables[tData.id]["width"] = tData.data;
		state.roomsDatas[state.selectedRoom].tables[tData.id]["height"] =
			tData.data;
	},
	setTableWidth(state, tData) {
		state.roomsDatas[state.selectedRoom].tables[tData.id]["width"] = tData.data;
	},
	setTableHeight(state, tData) {
		state.roomsDatas[state.selectedRoom].tables[tData.id]["height"] =
			tData.data;
	},
	setTableAngle(state, tData) {
		state.roomsDatas[state.selectedRoom].tables[tData.id]["angle"] = tData.data;
	},
	setTableForme(state, tData) {
		state.roomsDatas[state.selectedRoom].tables[tData.id]["forme"] = tData.data;
	},
	setTableNbCouvert(state, tData) {
		state.roomsDatas[state.selectedRoom].tables[tData.id]["nbCouvert"] =
			tData.data;
	},
	setTableLockState(state, tData) {
		state.roomsDatas[state.selectedRoom].tables[tData.tId]["isLock"] =
			tData.bool;
	},
	setTableState(state, data) {
		state.roomsDatas[data.room].tables[data.tid]["isBooked"] = data.value;
		state.roomsDatas[data.room].tables[data.tid]["isOccuped"] = data.occuped;
		state.roomsDatas[data.room].tables[data.tid]["resaId"] = data.resaId;
	},
	clearAllTableState(state) {
		Object.entries(state.roomsDatas).forEach(([index, room]) => {
			Object.entries(room.tables).forEach(([id, table]) => {
				table.isBooked = false;
				table.isOccuped = false;
				table.resaId = "";
			});
		});
	},
	/**
	 * set all services datas
	 * @param {*} state
	 * @param {*} dbData
	 */
	setLockedRooms(state, dbData) {
		state.lockedRooms = dbData;
	},
	setLockedTables(state, dbData) {
		// state.lockedTables = dbData
		Vue.set(state, "lockedTables", dbData);
	},
	resetStore(state) {
		state.modAddTable = false;
		state.modEdition = false;
		state.modLinkTable = false;
		state.isLoaded = false;
		state.unit = 25;
		// rooms datas
		state.selectedRoom = "";
		state.roomsDatas = {};
		state.roomsDatasUnsubscribe = null;
		state.roomsDatasUnsubscribe2 = [];
		state.widthStage = 100;
		state.heightStage = 100;
		// tables datas
		state.tableIsLoaded = false;
		state.displayTablesIds = [];
		state.selectedTables = [];
		state.tableIsDraggable = true;
	},
};

/*************************************
 Action
 **/
const actions = {
	cleanStore: function ({ state, rootState, commit, dispatch }, payload) {
		commit("resetStore");
	},
	async createNewRoom(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		let id = payload.id;
		if (state.roomsDatas[id])
			id = payload.id + state.roomsDatas[id].length.toString();
		return new Promise(async (resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			let roomData = {
				name: payload.name,
				roomid: payload.id,
				order: Object.entries(state.roomsDatas).length,
				restoid: uid,
			};

			await fetchPostHelper(
				ERequestType.ROOMS.CREATE,
				roomData,
				userDatas.token,
			)
				.then(function () {
					resolve(payload);
				})
				.catch(function (error) {
					// The document probably doesn't exist.
					console.error("Rooms creation error : ", error);
					reject(error);
				});
		});
	},

	/**
	 * create Cash Day datas
	 * @param payload:Object {
	 *  - days: [String] array of timestamp
	 *  - service: String
	 *  - content: datas
	 * }
	 **/
	async createLockedRooms(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		// Promise
		return new Promise(async (resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];
			// for tsIds create bdd entries
			for (const tsId of payload.days) {
				// create new cashday
				let newLockedRoom = {
					restoid: uid,
					ts: parseInt(tsId),
					service: payload.service,
					room: payload.room,
				};
				// send to db
				await fetchPostHelper(
					ERequestType.ROOMS.ADD_LOCKED_ROOMS,
					newLockedRoom,
					userDatas.token,
				)
					.then((res) => {
						resolve();
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			}
			// update local datas
			dispatch("loadlockedRooms");
			resolve();
		});
	},

	/**
	 * delete days datas Cash Day
	 * @param payload:Object {
	 *  - tIds: [String] array of timestamp
	 *  - service: String
	 * }
	 **/
	async deleteLockedRooms(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		// return new promise
		// delete in data base.then(resolve())
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];

		return new Promise(async (resolve, reject) => {
			// delete
			for (let i = 0; i < payload.days.length; i++) {
				// delete cashday object infos
				let deleteLockedRoom = {
					restoid: uid,
					ts: parseInt(payload.days[i]),
					service: payload.service,
					room: payload.room,
				};
				// delete on db
				await fetchPostHelper(
					ERequestType.ROOMS.DELETE_LOCKED_ROOMS,
					deleteLockedRoom,
					userDatas.token,
				)
					.then(async (res) => {
						resolve();
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			}
			// relaod datas
			dispatch("loadlockedRooms");
			resolve();
		});
	},
	async removeRoom(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			let roomToDelete = {
				roomid: payload.id,
				restoid: uid,
			};
			await fetchPostHelper(
				ERequestType.ROOMS.DELETE,
				roomToDelete,
				userDatas.token,
			)
				.then(async () => {
					await fetchPostHelper(
						ERequestType.TABLES.DELETE_BY_ROOM,
						roomToDelete,
						userDatas.token,
					)
						.then(function () {
							Vue.delete(state.roomsDatas, payload.id);
							resolve(payload);
						})
						.catch(function (error) {
							// The document probably doesn't exist.
							console.error("Tables delete error : ", error);
						});
				})
				.catch(function (error) {
					// The document probably doesn't exist.
					console.error("Rooms delete error : ", error);
					reject(error);
				});
		});
	},
	async updateRoomOrder(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			let roomToUpdate = {
				name: payload.name,
				roomid: payload.id,
				order: payload.order,
				restoid: uid,
			};

			await fetchPutHelper(
				ERequestType.ROOMS.UPDATE,
				roomToUpdate,
				userDatas.token,
			)
				.then(function () {
					resolve(payload.newName);
				})
				.catch(function (error) {
					// The document probably doesn't exist.
					console.error("Rooms update order error : ", error);
					reject(error);
				});
		});
	},
	unSelectedTables(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		unSelectResa = true,
	) {
		return new Promise((resolve, reject) => {
			if (!state.modAddTable) {
				commit("setUnSelectedTables");
				if (state.modLinkTable && unSelectResa) {
					commit("displayer/setPopupManageServices", false, { root: true });
					commit("newReservations/setSelectedResa", null, { root: true });
					commit("setModLinkTable", false);
				}
			}
			resolve();
		});
	},
	async setTableId(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			// get table who going to be modify
			let newTable = getters["getDisplayTableById"](payload.lastid);
			if (newTable) {
				newTable["id"] = payload.newid;
				newTable["idT"] = payload.newid;
				// clean localy
				Vue.set(
					state.roomsDatas[state.selectedRoom].tables,
					payload.newid,
					newTable,
				);
				Vue.delete(state.roomsDatas[state.selectedRoom].tables, payload.lastid);
				commit("setDisplayTableIds");
				commit("setSelectedTable", payload.newid);
			}
		});
	},
	async removeTable(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			if (state.selectedRoom !== "" && payload.toString !== "") {
				Vue.delete(
					state.roomsDatas[state.selectedRoom].tables,
					parseInt(payload),
				);
				commit("setDisplayTableIds");
			}
		});
	},
	async updateRoomName(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		newName,
	) {
		return new Promise(async (resolve, reject) => {
			if (newName !== "") {
				let userDatas = rootGetters["newUsers/getUser"];
				let uid = rootGetters["newUsers/getUidPublic"];

				let roomToUpdate = {
					name: newName,
					roomid: state.selectedRoom,
					restoid: uid,
				};

				await fetchPutHelper(
					ERequestType.ROOMS.UPDATE,
					roomToUpdate,
					userDatas.token,
				)
					.then(function () {
						resolve("Nom de salle mise à jour");
					})
					.catch(function (error) {
						// The document probably doesn't exist.
						console.error("Rooms update name error : ", error);
						reject(error);
					});
			}
		});
	},
	async createTable(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			let uid = rootGetters["newUsers/getUidPublic"];
			let tableToUpdate = payload.table;
			tableToUpdate.restoid = uid;
			tableToUpdate.roomid = state.selectedRoom;

			commit("setTable", tableToUpdate);
			commit("setDisplayTableIds");
		});
	},
	async updateLocalTable(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			commit("setTable", payload.table);
			commit("setDisplayTableIds");
		});
	},
	async saveRoom(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			await fetchGetHelper(
				ERequestType.TABLES.GET_BY_ROOMID,
				`restoid=${uid}&roomid=${state.selectedRoom}`,
				userDatas.token,
			).then(async (resTables) => {
				let BDDTables = resTables.data;
				let localTables = state.roomsDatas[state.selectedRoom].tables;

				Object.entries(localTables).forEach(async ([index, tableDatas]) => {
					let findId = BDDTables.filter((table) => {
						return parseInt(table.idT) === parseInt(index);
					});

					let tableToUpdate = tableDatas;
					tableToUpdate.restoid = uid;
					tableToUpdate.roomid = state.selectedRoom;

					// id exist update
					if (findId.length > 0) {
						await fetchPutHelper(
							ERequestType.TABLES.UPDATE,
							tableToUpdate,
							userDatas.token,
						)
							.then(function () {
								resolve();
							})
							.catch(function (error) {
								// The document probably doesn't exist.
								console.error("Table update error : ", error);
								reject(error);
							});
						// table didn't exist create it
					} else {
						await fetchPostHelper(
							ERequestType.TABLES.CREATE,
							tableToUpdate,
							userDatas.token,
						)
							.then(function () {
								resolve();
							})
							.catch(function (error) {
								// The document probably doesn't exist.
								console.error("Table update error : ", error);
								reject(error);
							});
					}
				});
				// check table to remove
				BDDTables.forEach(async (tableBDD) => {
					let idFind = Object.entries(localTables).filter((table) => {
						return parseInt(table[0]) === parseInt(tableBDD.idT);
					});
					// if no id is found delete it in bdd
					if (idFind.length === 0) {
						let tableToDelete = {
							roomid: state.selectedRoom,
							restoid: uid,
							idT: parseInt(tableBDD.idT),
						};
						await fetchPostHelper(
							ERequestType.TABLES.DELETE,
							tableToDelete,
							userDatas.token,
						).then(function () {
							dispatch("newReservations/syncRTCurrentResas", null, {
								root: true,
							});
							resolve("table removed");
						});
					}
				});
			});
		});
	},
	async updateTable(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			let uid = rootGetters["newUsers/getUidPublic"];

			let tableToUpdate = payload.table;

			tableToUpdate.restoid = uid;
			tableToUpdate.roomid = state.selectedRoom;

			commit("setTable", tableToUpdate);
			commit("setDisplayTableIds");
		});
	},
	updateTableWidth: function ({ state, rootState, commit, dispatch }, table) {
		commit("setTableWidth", table);
		dispatch("updateTable", {
			room: state.selectedRoom,
			table: state.roomsDatas[state.selectedRoom].tables[table.id],
		});
	},
	updateTableDiameter: function (
		{ state, rootState, commit, dispatch },
		table,
	) {
		commit("setTableDiameter", table);
		dispatch("updateTable", {
			room: state.selectedRoom,
			table: state.roomsDatas[state.selectedRoom].tables[table.id],
		});
	},
	updateTableHeight: function ({ state, rootState, commit, dispatch }, table) {
		commit("setTableHeight", table);
		dispatch("updateTable", {
			room: state.selectedRoom,
			table: state.roomsDatas[state.selectedRoom].tables[table.id],
		});
	},
	updateTableAngle: function ({ state, rootState, commit, dispatch }, table) {
		commit("setTableAngle", table);
		dispatch("updateTable", {
			room: state.selectedRoom,
			table: state.roomsDatas[state.selectedRoom].tables[table.id],
		});
	},
	updateTableForme: function ({ state, rootState, commit, dispatch }, table) {
		commit("setTableForme", table);
		dispatch("updateTable", {
			room: state.selectedRoom,
			table: state.roomsDatas[state.selectedRoom].tables[table.id],
		});
	},
	updateTableNbCouvert: function (
		{ state, rootState, commit, dispatch },
		table,
	) {
		commit("setTableNbCouvert", table);
		dispatch("updateTable", {
			room: state.selectedRoom,
			table: state.roomsDatas[state.selectedRoom].tables[table.id],
		});
	},
	updateTableLockState: function (
		{ state, rootState, commit, dispatch },
		payload,
	) {
		commit("setTableLockState", payload);
		dispatch("updateTable", {
			room: state.selectedRoom,
			table: state.roomsDatas[state.selectedRoom].tables[payload.tId],
		});
	},
	async updateRoomInformation(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		return new Promise(async (resolve, reject) => {
			let uid = rootGetters["newUsers/getUidPublic"];
			let userDatas = rootGetters["newUsers/getUser"];
			await fetchGetHelper(
				ERequestType.ROOMS.GET_ALL,
				`restoid=${uid}`,
				userDatas.token,
			).then(async (resRooms) => {
				resRooms.data.forEach(async (room) => {
					if (state.roomsDatas[room.roomid]) {
						Vue.set(state.roomsDatas[room.roomid], "name", room.name);
						Vue.set(state.roomsDatas[room.roomid], "order", room.order);
					} else {
						dispatch("loadRoomsStore");
					}
				});
				resolve();
			});
		});
	},
	async preLoadRoomsStore({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		if (state.modEdition) return;
		dispatch("loadRoomsStore");
	},
	async loadlockedRooms({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise(async (resolve, reject) => {
			await fetchGetHelper(ERequestType.ROOMS.LOCKED_ROOMS, `restoid=${uid}`)
				.then((res) => {
					commit("setLockedRooms", res.data);
					resolve();
				})
				.catch((err) => {
					console.error("Error on loading lockedRooms", err);
					reject(err);
				});
		});
	},
	async loadlockedTables({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise(async (resolve, reject) => {
			await fetchGetHelper(ERequestType.TABLES.LOCKED_TABLES, `restoid=${uid}`)
				.then((res) => {
					commit("setLockedTables", res.data);
					resolve();
				})
				.catch((err) => {
					console.error("Error on loading lockedRTables", err);
					reject(err);
				});
		});
	},
	async loadRoomsStore({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		// TODO: check async possibility with newReservations/loadOccupation
		return new Promise(async (resolve, reject) => {
			let uid = rootGetters["newUsers/getUidPublic"];
			let userDatas = rootGetters["newUsers/getUser"];

			await fetchGetHelper(
				ERequestType.ROOMS.GET_ALL,
				`restoid=${uid}`,
				userDatas.token,
			)
				.then(async (resRooms) => {
					// init vars
					let roomCount = 0;
					let rs = {};
					state.roomsDatas = {};
					state.tableIsLoaded = false;
					state.displayTablesIds = [];

					for (let i = 0; i < resRooms.data.length; i++) {
						let room = resRooms.data[i];
						rs[room.roomid] = room;
						await fetchGetHelper(
							ERequestType.TABLES.GET_BY_ROOMID,
							`restoid=${uid}&roomid=${room.roomid}`,
							userDatas.token,
						).then((resTables) => {
							let tids = [];
							let ts = {};
							let datas = {};
							datas["nbCouverts"] = 0;
							resTables.data.forEach((table) => {
								// hock for id
								let tmpTable = table;
								tmpTable.id = tmpTable.idT;
								// fill table table
								ts[table.idT] = tmpTable;
								datas["nbCouverts"] += table.nbCouvert;
								tids.push(filterInt(table.idT.toString()));
							});
							datas["idStart"] = tids[0];
							datas["idEnd"] = tids[tids.length - 1];
							datas["id"] = room.roomid;
							datas["name"] = room.name;
							if (room.order === undefined) {
								datas["order"] = roomCount;
								roomCount++;
							} else {
								datas["order"] = room.order;
								roomCount = state.roomsDatas.length;
							}
							datas["tables"] = ts;
							datas["nbCouvertsBooked"] = 0;

							commit("setRoomsLoadedState", true);
							commit("setRoomsDatas", { id: room.roomid, data: datas });
							commit("setDisplayTableIds");
							dispatch("newReservations/updateTableDispo", null, {
								root: true,
							});
						});
					}
					commit("setLoadedState", true);
					resolve();
				})
				.catch((err) => {
					console.error("loadRooms error", err);
					reject(err);
				});
		});
	},
	/**
	 * update CurrentService LockedTables
	 * @param {*} param0 {date, service, room, tables}
	 * @param {*} tables Array of locked tables
	 */
	updateCurrentServiceLockedTables: function (
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		// TODO: revoir l'utilitée de cette fonction
		return new Promise((resolve, reject) => {
			// get ts for date
			let ts = rootGetters["calendar/getDateToTimestamp"](payload.date);

			// get all tables of room
			let roomTables = state.roomsDatas[state.selectedRoom].tables;

			// get tables locked for room date and services
			let tablesLocked = [];
			payload.tablesIds.forEach((tid) => {
				tablesLocked.push(roomTables[tid]);
			});

			// send all locked tables for room date and services
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];
			let updateTables = {
				restoid: uid,
				service: payload.service,
				ts: ts,
				room: payload.room,
				tables: tablesLocked,
			};
			resolve(
				new Promise((resolve, reject) => {
					fetchPutHelper(
						ERequestType.TABLES.UPDATE_LOCKED_TABLES,
						updateTables,
						userDatas.token,
					)
						.then((res) => {
							//  .Then -> updates local state of lockedTables
							commit("setLockedTables", res.data);
							resolve(res);
						})
						.catch((err) => {
							console.error(err);
							reject(err);
						});
				}),
			);
		});
	},
	loadCurrentSelectRoom: function ({ state, rootState, commit }, roomId) {
		state.tableIsLoaded = false;
		state.selectedTables = [];
		commit("setSelectedRoom", roomId);
		commit("setDisplayTableIds");
	},
	closeEdition: function ({ state, rootState, commit }) {
		state.selectedTables = [];
		commit("setModAddTable", false);
		commit("setModEdition", false);
	},
};

/*************************************
 Helpers
 **/
function filterInt(value) {
	let regexp = /([0-9]+|Infinity)$/;
	if (value.match(regexp)) return Number(value);
	else return NaN;
}

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
